import { LOCALE_ID, Inject } from '@angular/core';
import { CalendarEventTitleFormatter, CalendarEvent } from 'angular-calendar';
import { DatePipe } from '@angular/common';

export class CustomEventTitleFormatter extends CalendarEventTitleFormatter {
  constructor(@Inject(LOCALE_ID) private locale: string) {
    super();
  }

  // you can override any of the methods defined in the parent class

  month(event: CalendarEvent): string {
    const {jobNumber, locationShortName, remarks, users, beginDate, finishDate, teamName } = event.meta.data;

    const jobNumberText = '<div>Job Number : ' +
      ((jobNumber !== null) ? `${jobNumber}` : '') + '</div>';

    const locationShortNameText = '<div>Site Short Name : ' +
      ((locationShortName !== null) ? `${locationShortName}` : '') +
      '</div>';

    const remarkText = '<div>Remarks : ' +
      ((remarks !== null && remarks.length > 0) ? `${remarks}` : '') +
      '</div>';

    const technician = '<div>Technician : ' +
    ((users !== null && users.length > 0) ? `${users}` : '') +
    '</div>';

    const duration = '<div>Duration : ' + beginDate +
    ((finishDate !== null && finishDate.length > 0) ? ` – ${finishDate}` : '') +
    '</div>';

    const team = '<div>Team : ' +
    ((teamName !== null && teamName.length > 0) ? `${teamName}` : '') +
    '</div>';

    return `<b>${new DatePipe(this.locale).transform(
      event.start,
      'd/M HH:mm',
      this.locale
    )}</b> ${event.title}` +
      `<div class='pl-3 mb-3'>${jobNumberText} ${remarkText} ${locationShortNameText} ${technician} ${duration} ${team} </div>`;

  }

  week(event: CalendarEvent): string {
    return `<b>${new DatePipe(this.locale).transform(
      event.start,
      'd/M HH:mm',
      this.locale
    )}</b> ${event.title}`;
  }

  day(event: CalendarEvent): string {
    return `<b>${new DatePipe(this.locale).transform(
      event.start,
      'd/M HH:mm',
      this.locale
    )}</b> ${event.title}`;
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/schedule/custom-event-title-formatter.provider.ts